module.exports = "<button ng-disabled=\"submitButtonDisabled\" ng-class=\"buttonClass\" ng-click=\"handleClick()\" translate>\n    {{labelKey}}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/directives/templates/mfp-submit-button.html
// module id = 651
// module chunks = 0